import { Mail, MapPin, ExternalLink, Lock, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-foreground text-background pt-20 pb-10 border-t border-foreground">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-background/15">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <img
                src="https://customer-assets.emergentagent.com/job_aussie-4wd-hub/artifacts/u1tlocwk_Overlander%20mobility%20logo%20%28no%20text%29%20%282%29.png"
                alt="Overlander Mobility"
                className="h-10 w-10 object-contain"
              />
              <span className="font-display font-bold tracking-tight uppercase">
                Overlander <span className="text-primary">Mobility</span>
              </span>
            </a>
            <p className="mt-5 text-sm text-background/70 leading-relaxed max-w-md">
              Overlander Mobility is the authorised Australian distributor of the TerrainHopper
              Overlander range. Based in Geelong, Victoria, with trials and service support travelling
              nationwide.
            </p>
            <p className="mt-3 text-xs text-background/50 italic">
              TerrainHopper&trade; is a registered trademark of TerrainHopper Ltd. (UK).
              This page is operated by Overlander Mobility (Australia).
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-primary">Get in touch</h4>
            <ul className="mt-5 space-y-3 text-sm text-background/80">
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                <a href="mailto:info@overlandermobility.com.au" className="hover:text-primary">info@overlandermobility.com.au</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-primary shrink-0 mt-0.5" /> Geelong, Victoria
              </li>
              <li className="flex items-start gap-3">
                <ExternalLink className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                <a href="https://overlandermobility.com.au/" target="_blank" rel="noreferrer" className="hover:text-primary">overlandermobility.com.au</a>
              </li>
              <li className="flex items-start gap-3">
                <Instagram className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                <a
                  href="https://www.instagram.com/overlander_mobility/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-instagram-link"
                  className="hover:text-primary"
                >
                  @overlander_mobility
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-primary">Trials travel Australia-wide</h4>
            <ul className="mt-5 grid grid-cols-2 gap-y-2 text-sm text-background/80">
              {["Geelong (HQ)", "Melbourne", "Ballarat", "Sydney", "Brisbane", "Adelaide", "Perth", "Hobart"].map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-background/60">
              Interstate trials arranged on request. Australia-wide service support via
              our technician network.
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-background/60">
          <div>© {new Date().getFullYear()} Overlander Mobility · Authorised Australian distributor of TerrainHopper&trade;</div>
          <div className="flex items-center gap-6">
            <a href="https://overlandermobility.com.au/" target="_blank" rel="noreferrer" className="hover:text-primary">overlandermobility.com.au</a>
            <a href="https://www.terrainhopper.com/" target="_blank" rel="noreferrer" className="hover:text-primary">TerrainHopper.com</a>
            <a
              href="/admin/leads"
              data-testid="footer-staff-login"
              className="inline-flex items-center gap-1.5 text-background/50 hover:text-primary transition-colors"
            >
              <Lock className="h-3 w-3" /> Staff login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
